
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60","fill":"none","viewBox":"0 0 60 60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M40.26 9H20.17c-.85 0-1.54.69-1.54 1.54v2.14c0 .85.69 1.54 1.54 1.54h20.09c.85 0 1.54-.69 1.54-1.54v-2.14c0-.85-.69-1.54-1.54-1.54zm1.55 8.44c-2.25-1.25-2.75-1.99-2.75-3.22H21.39c0 1.23-.5 1.97-2.75 3.22-2.25 1.25-3.56 1.42-3.56 6.92v18.61c0 3.63 2.79 7.32 7.56 7.32h15.17c4.77 0 7.56-3.69 7.56-7.32V24.36c0-5.5-1.32-5.68-3.56-6.92zM15 24.3h30.37m-.09 18.79H15.09"}}),_c('path',{attrs:{"stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M26.12 39.59c-3.24 0-5.86-2.63-5.86-5.86 0-3.23 2.63-5.86 5.86-5.86m8.21 11.72c3.24 0 5.86-2.63 5.86-5.86 0-3.24-2.63-5.86-5.86-5.86"}})])
          )
        }
      }
    